module.exports = __webpack_public_path__ + "static/img/et_08.2a6c2be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/et/et_08.jpg
// module id = 9Tiy
// module chunks = 1